/* Load once after the article markup, or with defer. Safe to load twice. */
(() => {
  const init = () => {
    document.querySelectorAll('.imano-blog-article .imano-table-shell').forEach((shell) => {
      if (shell.dataset.imanoScrollReady === 'true') return;
      const scroller = shell.querySelector('.imano-table-scroll');
      const table = scroller && scroller.querySelector('table.imano-compare-table');
      if (!scroller || !table) return;
      shell.dataset.imanoScrollReady = 'true';
      let frame = 0;
      const update = () => {
        frame = 0;
        const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const position = Math.max(0, Math.min(max, scroller.scrollLeft));
        const overflow = max > 1;
        shell.dataset.overflow = String(overflow);
        shell.dataset.canLeft = String(overflow && position > 1);
        shell.dataset.canRight = String(overflow && position < max - 1);
        scroller.tabIndex = overflow ? 0 : -1;
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };
      scroller.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(schedule);
        observer.observe(scroller);
        observer.observe(table);
      }
      if (document.fonts) document.fonts.ready.then(schedule);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();